import React from "react";
import { styled } from "@linaria/react";
import { color } from "@ui";
import Popper from "@ui/Popper";

interface P {
  overlay: (() => React.ReactNode) | React.ReactNode;
  children: React.ReactElement;
}

function Tooltip({ overlay, children }: P) {
  return (
    <StyledPopper
      hover
      keepOpenOnOverlayActive
      overlay={overlay}
      groupId="QuantitySelector"
      openDelay={1000}
      closeDelay={200}
      openGroupDelay={300}
      gap={5}
      placement="right-start"
    >
      {children}
    </StyledPopper>
  );
}

const StyledPopper = styled(Popper)`
  border-radius: 0px 4px 4px 4px;
  background-color: ${color.hydrogen};
  color: ${color.carbon800};
  padding: 12px;
  min-width: 220px;
  max-width: 300px;
  box-shadow: 0px 7px 6px #00000029;
  cursor: auto;
  white-space: normal;
`;

export default Tooltip;
